module.exports = __webpack_public_path__ + "static/media/liberty-insurance.63d538f0.png";